export default {
  getScene(state) {
    return state.scene;
  },
};
